export class Notification {

    id: string;
    message: string;
    type: 'link';
    createdDateTime: string;
    readDateTime: string;
    settings: any;
    
}